import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  isLoggedIn: boolean;
  isPaid: boolean;
}

// NOTE: 테스트용
const initialState: AuthState = {
  isLoggedIn: true,
  isPaid: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload;
    },
    setPaid: (state, action: PayloadAction<boolean>) => {
      state.isPaid = action.payload;
    },
  },
});

export const { setLoggedIn, setPaid } = authSlice.actions;
export default authSlice.reducer;
